import { EnterpriseModel } from './enterprise.model';
import { CityModel } from 'src/app/models/management/city.model';
export class EnterpriseCityModel {
  enterpriseCityId: number = 0;
  enterpriseId: number = 0;
  enterprise: EnterpriseModel = new EnterpriseModel();
  cityId: number = 0;
  city: CityModel = new CityModel();
  swIcaSelfRetainer: boolean = false;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}